import React from "react";
import MediaQuery from "react-responsive";

const HiddenOn = ({ children, width }) => (
  <MediaQuery minWidth={width + 1}>{children}</MediaQuery>
);

HiddenOn.displayName = "HiddenOn";

export default HiddenOn;
